import { render } from "./PatientReportEmailView.vue?vue&type=template&id=4efb5e82"
import script from "./PatientReportEmailView.vue?vue&type=script&lang=js"
export * from "./PatientReportEmailView.vue?vue&type=script&lang=js"

import "./PatientReportEmailView.vue?vue&type=style&index=0&id=4efb5e82&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PatientReportEmailView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4efb5e82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4efb5e82', __exports__)) {
    console.log('reload')
    api.reload('4efb5e82', __exports__)
  }
  
  module.hot.accept("./PatientReportEmailView.vue?vue&type=template&id=4efb5e82", () => {
    console.log('re-render')
    api.rerender('4efb5e82', render)
  })

}


export default __exports__